import {ConfigureModulePermissionCodes, InternalToolsModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const internalTabs = defineTabDef({
  tasks: {
    tabName: 'tasks',
    tabTitle: 'Tasks',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_tasks],
  },
  logs: {
    tabName: 'logs',
    tabTitle: 'Logs',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_logs],
  },
  revisions: {
    tabName: 'revisions',
    tabTitle: 'Revisions',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_revisions],
  },
  'batch-analysis': {
    tabName: 'batch-analysis',
    tabTitle: 'Batch Analysis',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_batch_analysis],
  },
  'analysis-runs': {
    tabName: 'analysis-runs',
    tabTitle: 'Analysis Runs',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_all_analysis_runs],
  },
  'analysis-appendix': {
    tabName: 'analysis-appendix',
    tabTitle: 'Analysis Appendix',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_analysis_appendix],
  },
  'audit-logs': {
    tabName: 'audit-logs',
    tabTitle: 'Audit Logs',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_audit_log],
  },
  'email-generator': {
    tabName: 'email-generator',
    tabTitle: 'Email Generator',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_email_generator],
  },
  'clean-item-list': {
    tabName: 'clean-item-list',
    tabTitle: 'Clean Item List',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_clean_item_list],
  },
  map: {
    tabName: 'map',
    tabTitle: 'Map',
    requiredAnyPermission: [ConfigureModulePermissionCodes.view_map],
  },
  'rfp-feasibility': {
    tabName: 'rfp-feasibility',
    tabTitle: 'RFP Feasibility',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_rfp_feasibility_internal],
  },
} as const);
